export default "__VITE_ASSET__BCKxHKik__"